// extracted by mini-css-extract-plugin
export default {"container":"EventDetailsOrderForm_container__al6Uk"};